module.exports = __webpack_public_path__ + "img/xiazai1.07157ca6.png";